import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'my-app-footer',
  styles: [],
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ]
})

export class AppFooterComponent implements OnInit {
  public AppConfig: any;

  ngOnInit() {
    this.AppConfig = environment;
  }
}
